// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2eEtD","text":"za6_X"};